import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Varkala extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Sree Padmanabhaswamy Temple",
        image: "/assets/img/padmanabha-temple.jpg",
        description: "One of the richest temples in the world, dedicated to Lord Vishnu. The temple showcases stunning Dravidian architecture and intricate stone carvings.",
        highlight: "Richest Temple in World",
        bestTime: "Morning Hours",
        duration: "2-3 Hours",
        dressCode: "Traditional attire required"
      },
      {
        name: "Kovalam Beach",
        image: "/assets/img/kovalam-beach.jpg",
        description: "Famous crescent-shaped beach with three separate beaches: Lighthouse Beach, Hawah Beach, and Samudra Beach. Perfect for swimming and sunbathing.",
        highlight: "Paradise of the South",
        bestTime: "Oct-Mar",
        duration: "Full Day",
        activities: "Swimming, Surfing, Ayurvedic Massage"
      },
      {
        name: "Napier Museum",
        image: "/assets/img/napier-museum.jpeg",
        description: "A 19th-century museum with Indo-Saracenic architecture, housing ancient artifacts, bronze idols, and natural history exhibits.",
        highlight: "Historic Architecture",
        bestTime: "All Year",
        duration: "2 Hours",
        closedOn: "Mondays"
      },
      {
        name: "Varkala Beach",
        image: "/assets/img/varkala-beach.jpg",
        description: "A stunning cliff beach with natural springs known for their medicinal properties. The Papanasam Beach is believed to wash away sins.",
        highlight: "Cliff Beach",
        bestTime: "Oct-Mar",
        duration: "Half Day",
        special: "Natural Springs"
      },
      {
        name: "Kuthiramalika Palace",
        image: "/assets/img/kuthiramalika.jpeg",
        description: "A traditional Kerala palace built by Maharaja Swathi Thirunal, known for its exquisite woodwork and 122 horses carved into the walls.",
        highlight: "Royal Heritage",
        bestTime: "Morning",
        duration: "1-2 Hours",
        nearby: "Adjacent to Padmanabhaswamy Temple"
      },
      {
        name: "Ponmudi Hill Station",
        image: "/assets/img/ponmudi.jpg",
        description: "A scenic hill station with winding roads, misty valleys, tea plantations, and waterfalls. Ideal for trekking and nature walks.",
        highlight: "Golden Peak",
        bestTime: "Sep-May",
        duration: "Full Day",
        altitude: "1,100 m"
      },
      {
        name: "Shanghumukham Beach",
        image: "/assets/img/shanghumukham.jpg",
        description: "A popular sunset spot with the iconic mermaid statue and children's park. Known for its golden sands and evening cultural performances.",
        highlight: "Sunset Paradise",
        bestTime: "Evening",
        duration: "2 Hours",
        special: "Mermaid Statue"
      },
      {
        name: "Neyyar Dam & Wildlife Sanctuary",
        image: "/assets/img/neyyar-dam.jpg",
        description: "A picturesque dam with crocodile rehabilitation center, lion safari park, and boating facilities amidst lush greenery.",
        highlight: "Wildlife & Boating",
        bestTime: "Oct-Feb",
        duration: "Half Day",
        activities: "Boating, Safari, Trekking"
      }
    ];

    const experiences = [
      {
        title: "Ayurvedic Wellness",
        description: "Rejuvenate with authentic Ayurvedic treatments at world-class wellness centers",
        icon: "fas fa-spa"
      },
      {
        title: "Beach Activities",
        description: "Enjoy swimming, surfing, and sunbathing at pristine beaches",
        icon: "fas fa-umbrella-beach"
      },
      {
        title: "Temple Tours",
        description: "Explore ancient temples with rich architectural heritage",
        icon: "fas fa-pray"
      },
      {
        title: "Hill Station Escape",
        description: "Trek through misty hills and tea plantations at Ponmudi",
        icon: "fas fa-mountain"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Thiruvananthapuram District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to February", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Trivandrum International Airport (6 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Thiruvananthapuram Central (3 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Temples, Beaches, Ayurveda", icon: "fas fa-leaf" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const culturalHighlights = [
      {
        name: "Kathakali Performances",
        venue: "Kuthiramalika Palace, Margi Theatre",
        description: "Traditional dance-drama performances showcasing Kerala's rich cultural heritage"
      },
      {
        name: "Attukal Pongala Festival",
        month: "February-March",
        description: "World's largest gathering of women for the famous Pongala offering"
      },
      {
        name: "Navaratri Celebrations",
        month: "September-October",
        description: "Grand celebrations at Padmanabhaswamy Temple with musical performances"
      }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/trivandrum-hero.png" alt="Thiruvananthapuram" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Evergreen City of India</span>
            </div>
            <h1 className="dest-hero-title">Thiruvananthapuram</h1>
            <p className="dest-hero-subtitle">
              Where ancient traditions meet coastal serenity, and spirituality embraces modernity
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Thiruvananthapuram District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Thiruvananthapuram</h2>
                <p className="dest-intro-description">
                  Thiruvananthapuram, also known as Trivandrum, is the capital city of Kerala and a 
                  fascinating blend of tradition and modernity. The city's name means "The Abode of 
                  Lord Anantha" - the sacred serpent upon whom Lord Vishnu reclines, reflecting its 
                  deep spiritual roots.
                </p>
                <p className="dest-intro-description">
                  From the majestic Sree Padmanabhaswamy Temple to the serene Kovalam beaches, 
                  Trivandrum offers a diverse range of experiences. The city is also a hub for 
                  Ayurveda, with numerous wellness centers offering authentic treatments. Its 
                  pristine beaches, historic museums, and lush hill stations make it a perfect 
                  destination for all types of travelers.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Thiruvananthapuram was named the best city in Kerala for quality of life by several surveys, and is known as the "Evergreen City of India".</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Trivandrum</h2>
            <p className="dest-section-subtitle">
              Unique ways to explore the capital city
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="attractions-section">
          <div className="section-header">
            <h2 className="section-title-centered">Top Attractions in Thiruvananthapuram</h2>
            <p className="section-subtitle">
              Discover the most beautiful places that make the capital city a must-visit destination
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        {attraction.dressCode && (
                          <div className="dress-code">
                            <i className="fas fa-tshirt"></i>
                            <span>{attraction.dressCode}</span>
                          </div>
                        )}
                        <button className="dest-read-more-btn">Read More</button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Temple Heritage Section */}
        <div className="temple-section">
          <div className="temple-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="temple-content">
                <div className="temple-badge">Spiritual Heritage</div>
                <h2 className="temple-title">Sree Padmanabhaswamy Temple</h2>
                <p className="temple-description">
                  The Sree Padmanabhaswamy Temple is one of the most revered and wealthiest temples 
                  in the world, dedicated to Lord Vishnu. The temple's architecture is a stunning 
                  example of Dravidian style, with intricate stone carvings and a 100-foot tall 
                  Gopuram (tower) that dominates the skyline.
                </p>
                <p className="temple-description">
                  The presiding deity, Lord Padmanabhaswamy, is depicted in the reclining posture 
                  on the serpent Anantha. The temple's vaults are believed to hold immense treasures, 
                  making it a site of historical and cultural significance. The temple follows strict 
                  dress codes and rituals, preserving centuries-old traditions.
                </p>
                <div className="temple-facts">
                  <div className="fact">
                    <i className="fas fa-clock"></i>
                    <span>Open: 3:30 AM - 12:00 PM, 5:00 PM - 7:20 PM</span>
                  </div>
                  <div className="fact">
                    <i className="fas fa-tshirt"></i>
                    <span>Dress Code: Traditional attire only</span>
                  </div>
                  <div className="fact">
                    <i className="fas fa-ticket-alt"></i>
                    <span>Special Darshan tickets available online</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Beach Section */}
        <div className="beach-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="beach-content">
                <div className="beach-badge">Coastal Paradise</div>
                <h2 className="beach-title">Kovalam - The Queen of Beaches</h2>
                <p className="beach-description">
                  Kovalam is one of India's most famous beach destinations, known for its crescent-shaped 
                  coastline and pristine waters. The beach is divided into three main sections: Lighthouse 
                  Beach, Hawah Beach, and Samudra Beach, each offering a unique experience.
                </p>
                <p className="beach-description">
                  Lighthouse Beach is the most popular, featuring a 35-meter lighthouse offering panoramic 
                  views. Hawah Beach is ideal for swimming, while Samudra Beach provides a more tranquil 
                  atmosphere. The beaches are lined with Ayurvedic massage centers, seafood restaurants, 
                  and boutique shops.
                </p>
                <div className="beach-activities">
                  <div className="activity">
                    <i className="fas fa-swimmer"></i>
                    <span>Swimming & Surfing</span>
                  </div>
                  <div className="activity">
                    <i className="fas fa-spa"></i>
                    <span>Ayurvedic Massage</span>
                  </div>
                  <div className="activity">
                    <i className="fas fa-utensils"></i>
                    <span>Fresh Seafood</span>
                  </div>
                  <div className="activity">
                    <i className="fas fa-sun"></i>
                    <span>Sunset Views</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Cultural Section */}
        <div className="cultural-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Cultural Experiences</h2>
              <p className="dest-section-subtitle">Immerse yourself in the rich cultural heritage</p>
            </div>
            <Row className="cultural-grid">
              {culturalHighlights.map((item, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="cultural-col">
                  <div className="cultural-card">
                    <div className="cultural-icon">
                      <i className="fas fa-mask"></i>
                    </div>
                    <h3 className="cultural-name">{item.name}</h3>
                    {item.venue && <p className="cultural-venue"><i className="fas fa-location-dot"></i> {item.venue}</p>}
                    {item.month && <p className="cultural-month"><i className="fas fa-calendar"></i> {item.month}</p>}
                    <p className="cultural-description">{item.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Thiruvananthapuram</h2>
              <p className="dest-section-subtitle">Make the most of your visit to the capital city</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>Dress Code</h4>
                  <p>Traditional attire required for temple visits. Cover shoulders and knees at religious sites.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-umbrella-beach"></i>
                  </div>
                  <h4>Beach Safety</h4>
                  <p>Follow lifeguard instructions at Kovalam. Avoid swimming during monsoon season (June-September).</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-taxi"></i>
                  </div>
                  <h4>Getting Around</h4>
                  <p>Use pre-paid taxis or app-based cabs. Auto-rickshaws are convenient for short distances.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Kerala Sadya, seafood at Kovalam, and authentic Kerala-style beef curry.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Ready to Explore the Capital City?</h3>
            <p>Let us help you discover the spiritual and coastal beauty of Thiruvananthapuram</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}